import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useConsent } from './consent/ConsentProvider';
import { isAnalyticsEnabled } from '../lib/consent';

// Manual pageviews keep Seline behind the same runtime setting as GA, including
// withdrawal after the SDK loads. Auto mode would keep its own route listeners.
export default function SelineAnalytics() {
  const { pathname } = useLocation();
  const { analyticsAllowed } = useConsent();
  const tagRef = useRef(null);

  useEffect(() => () => {
    tagRef.current?.remove();
    tagRef.current = null;
  }, []);

  useEffect(() => {
    if (!analyticsAllowed || !['cursivefont.org', 'www.cursivefont.org'].includes(window.location.hostname)) return;
    const page = () => {
      if (!isAnalyticsEnabled()) return;
      try { window.seline?.page(); } catch { /* Analytics must not break the generators. */ }
    };
    if (window.seline?.page) { page(); return; }
    if (!tagRef.current) {
      const tag = document.createElement('script');
      tag.src = 'https://cdn.seline.com/seline.js';
      tag.async = true;
      tag.dataset.token = '45e95d3dd0e13e1';
      tag.dataset.seline = '';
      tag.dataset.autoPageView = 'false';
      tag.dataset.cookie = 'false';
      tag.dataset.cookieOnIdentify = 'false';
      tag.dataset.outbound = 'false';
      tag.onerror = () => { tag.remove(); if (tagRef.current === tag) tagRef.current = null; };
      tagRef.current = tag;
      document.head.appendChild(tag);
    }
    const tag = tagRef.current;
    tag.addEventListener('load', page);
    return () => tag.removeEventListener('load', page);
  }, [pathname, analyticsAllowed]);

  return null;
}
